import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { ArrowLeft } from "components/icons/ArrowLeft";
import { MenuDotsVertical } from "components/icons/MenuDotsVertical";
import { ReactNode } from "react";

export type MobileTaskMenuItem = {
  key: string;
  label: string;
  icon?: ReactNode;
  onSelect?: () => void;
  href?: string;
};

export type MobileTaskMetaItem = {
  key: string;
  node: ReactNode;
};

type MobileTaskPageHeaderProps = {
  title: string;
  onBack: () => void;
  titleSuffix?: ReactNode;
  metaItems: MobileTaskMetaItem[];
  menuItems: MobileTaskMenuItem[];
  chatControl?: ReactNode;
};

const MenuItem = ({ item }: { item: MobileTaskMenuItem }) => {
  const menuItem = (
    <Dropdown.Item icon={item.icon} onSelect={item.onSelect}>
      {item.label}
    </Dropdown.Item>
  );

  if (item.href) {
    return (
      <ConditionalLink to={item.href} target="_blank">
        {menuItem}
      </ConditionalLink>
    );
  }

  return menuItem;
};

export const MobileTaskPageHeader = ({
  title,
  onBack,
  titleSuffix,
  metaItems,
  menuItems,
  chatControl,
}: MobileTaskPageHeaderProps) => (
  <div className="t-flex t-flex-col t-gap-0.5 t-border-0 t-border-b t-border-solid t-border-neutral-10 t-px-4 t-py-3">
    <div className="t-flex t-items-start t-gap-2">
      <Button
        customType="ghost_icon"
        size="small"
        onClick={onBack}
        aria-label="Back"
      >
        <ArrowLeft size="16px" />
      </Button>

      <div className="t-flex t-min-w-0 t-flex-1 t-flex-wrap t-items-center t-gap-1 t-pt-1 t-text-subtext t-text-text-100">
        {title}
        {titleSuffix}
      </div>

      <div className="t-flex t-shrink-0 t-items-center t-gap-1">
        {menuItems.length > 0 && (
          <Dropdown.Root>
            <Dropdown.Trigger asChild>
              <Button customType="ghost_icon" size="small" aria-label="More">
                <MenuDotsVertical />
              </Button>
            </Dropdown.Trigger>
            <Dropdown.Portal>
              <Dropdown.Content align="end" sideOffset={4}>
                {menuItems.map((item) => (
                  <MenuItem key={item.key} item={item} />
                ))}
              </Dropdown.Content>
            </Dropdown.Portal>
          </Dropdown.Root>
        )}
        {chatControl}
      </div>
    </div>

    <div className="t-flex t-flex-wrap t-items-center t-gap-y-1 t-pl-10">
      {metaItems.map(({ key, node }) => (
        <div
          key={key}
          className="t-flex t-items-center t-pr-2 before:t-mr-2 before:t-h-3 before:t-w-px before:t-bg-neutral-10 before:t-content-[''] first:before:t-hidden empty:t-hidden"
        >
          {node}
        </div>
      ))}
    </div>
  </div>
);
